import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BookingComponent } from './booking/booking.component';
import { HotelComponent } from './hotel/hotel.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { UserComponent } from './user/user.component';
import { LoginService } from './login/login.service';

const routes: Routes = [
                        { path: 'home', component: HomeComponent },
                        { path: 'booking', component: BookingComponent, canActivate: [LoginService] },
                        { path: 'hotel', component: HotelComponent, canActivate: [LoginService] },
                        { path: 'transactions', component: TransactionsComponent, canActivate: [LoginService] },
                        { path: 'user', component: UserComponent, canActivate: [LoginService] },
                        
                        { path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [LoginService]},
                        
                        { path: '', redirectTo: '/home', pathMatch: 'full' },   // Default route
                    ];

@NgModule( {
    imports: [RouterModule.forRoot( routes )],
    exports: [RouterModule]
} )
export class AppRoutingModule { }



